import React from 'react';
import { fx } from '../../fx.js';

const h = React.createElement;

const SR = { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' };

/**
 * Rolls a number column by column like a mechanical counter. Non-digits stay put.
 *
 * @param {object} p
 * @param {string|number} p.value
 * @param {number} [p.stagger]
 * @param {number} [p.duration]
 * @param {React.CSSProperties} [p.style]
 */
export function Odometer({ value, stagger = 55, duration = 560, style }) {
  const str = String(value);
  const [shown, setShown] = React.useState(() => (fx.reduced && fx.reduced() ? str : str.replace(/\d/g, '0')));
  React.useEffect(() => { const id = requestAnimationFrame(() => requestAnimationFrame(() => setShown(str))); return () => cancelAnimationFrame(id); }, [str]);
  const chars = Array.from(str), prev = Array.from(shown);
  const n = chars.length;
  return h('span', { style: { position: 'relative', display: 'inline-flex', alignItems: 'flex-start', fontVariantNumeric: 'tabular-nums', ...style } },
    h('span', { style: SR }, str),
    chars.map((ch, i) => {
      const fromRight = n - 1 - i;
      if (!/\d/.test(ch)) return h('span', { key: 'c' + fromRight, 'aria-hidden': true, style: { display: 'inline-block', height: '1.1em', lineHeight: '1.1em', whiteSpace: 'pre' } }, ch);
      const target = prev.length === n && /\d/.test(prev[i]) ? Number(prev[i]) : Number(ch);
      return h('span', { key: 'd' + fromRight, 'aria-hidden': true, style: { display: 'inline-block', height: '1.1em', lineHeight: '1.1em', overflow: 'hidden', verticalAlign: 'top' } },
        h('span', { className: 'gx-odo', style: { display: 'block', transform: `translateY(${-target * 1.1}em)`, transition: `transform ${duration}ms cubic-bezier(.34,1.45,.55,1) ${i * stagger}ms` } },
          '0123456789'.split('').map((d) => h('span', { key: d, style: { display: 'block', height: '1.1em' } }, d))));
    }));
}
